const HotelSearchBar = ({ value, onChange }) => (
    <input
      type="text"
      placeholder="Search hotels..."
      className="   w-full p-3 border rounded-md mb-6 shadow-sm"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
  
  export default HotelSearchBar;
  